import * as React from 'react';

import * as styles from './HeadingWrapper.css';

export interface IHeadingWrapperProps {
  mapLink: React.ReactNode;
  heading: React.ReactNode;
  quickLinks: React.ReactNode;
  breadcrumbs: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const HeadingWrapper = ({ mapLink, heading, quickLinks, breadcrumbs, subtitle }: IHeadingWrapperProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['breadcrumbs']}>{breadcrumbs}</div>
      <div className={styles['container--inner']}>
        <div className={styles['heading-section']}>
          {heading}
          {subtitle}
          {quickLinks}
        </div>
        {mapLink && <div className={styles['map']}>{mapLink}</div>}
      </div>
    </div>
  );
};
